export const getDxAiPatientClinicMuiDivider = (palette: any) => ({
  MuiDivider: {
    styleOverrides: {
      root: {
        // backgroundColor: palette["outline-variant"].main,
        backgroundColor: "#BEC9C6",
      },
    },
  },
});
